import $ from 'jquery';

export default function searchModule() {
  const searchElement = $('.search-input');
  if (searchElement.length) {
    return import(/* webpackChunkName: "search" */ '../search')
      .then(({ default: Search }) => {
        const search = new Search();
        return search;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
